
export default appConfig => {
	const http = axios.create({
		baseURL: appConfig.baseURL,
		withCredentials: false,
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json'
		}
	});

	return http;
};

export function createAxios(config) {
	const http = axios.create({
		baseURL: config.baseURL_v3,
		withCredentials: false,
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json'
		}
	});

	return http;
}
